var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8075 10.3789C6.39793 9.81489 7.18302 9.50018 7.99953 9.50018C8.81603 9.50018 9.60112 9.81489 10.1916 10.3789",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68616 8.25754C4.83926 7.13093 6.38739 6.50018 7.99951 6.50018C9.61162 6.50018 11.1598 7.13093 12.3129 8.25754",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56653 6.13622C3.28161 4.44702 5.59229 3.50018 7.99955 3.50018C10.4068 3.50018 12.7175 4.44702 14.4326 6.13622",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.25C8.41421 13.25 8.75 12.9142 8.75 12.5C8.75 12.0858 8.41421 11.75 8 11.75C7.58579 11.75 7.25 12.0858 7.25 12.5C7.25 12.9142 7.58579 13.25 8 13.25Z",
    fill: "#103045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSignal);
export default __webpack_public_path__ + "static/media/fullSignal.a480fa3bc33b92e97e1c0f8f48560bff.svg";
export { ForwardRef as ReactComponent };